/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

export const APP_URL = 'https://app.sequoia.fitness'
export const ENAMAD_URL = 'https://trustseal.enamad.ir/?id=635848&Code=HWcy5MT4nHrZ8Kn2Bwk4xV0QnCPYTjIm'

export const ROOT = {
  text: 'سلام! چه کاری ازم برمیاد؟',
  options: [
    { label: 'سکویا رو بهم معرفی کن', to: 'about' },
    { label: 'پلن مناسب من کدومه؟', to: 'plans' },
    { label: 'ابزارهای سکویا رو بهم نشون بده', to: 'tools' },
    { label: 'قوانین و حریم خصوصی رو توضیح بده', to: 'rules' },
    { label: 'راه‌های ارتباط با سکویا رو بگو', to: 'links' },
    { label: 'مشاوره‌ی رایگان می‌خوام', to: 'support' },
  ],
}

export const NODES = {
  plans: {
    text: 'می‌خوای برای انتخاب پلن مناسب کمکت کنم؟',
    options: [
      { label: 'پلن‌ها رو باهم مقایسه کن', to: 'plan_compare' },
      { label: 'روش‌های پرداخت و تخفیف رو بگو', to: 'plan_pay' },
    ],
    nav: { label: 'صفحه‌ی پلن‌ها', path: '/plans' },
  },
  plan_compare: {
    text: 'در چهار دسته:',
    bullets: [
      { b: 'پایه —', t: 'Sequoia Pro: ابزارها، ویدیوها و برنامه‌ساز، بدون مربی اختصاصی.' },
      { b: 'تخصصی —', t: 'Complete، Training، Nutrition، Fix.' },
      { b: 'حرفه‌ای —', t: 'Elite (تماس ماهانه) و Apex (تماس هفتگی + جلسه‌ی تمرین تحت نظارت)، هر دو با برنامه‌ریزی سه‌ماهه.' },
      { b: 'کلاس —', t: 'آنلاین یا حضوری، خصوصی یا نیمه‌خصوصی.' },
    ],
    nav: { label: 'جدول مقایسه‌ی پلن‌ها', path: '/plans' },
  },
  plan_pay: {
    text: 'دو راه پرداخت داری:',
    bullets: [
      { b: 'درگاه بانکی —', t: 'بعد از تأیید تراکنش، سرویس بلافاصله فعال می‌شه.' },
      { b: 'کارت‌به‌کارت —', t: 'تصویر رسید رو آپلود می‌کنی و بعد از بررسی و تأیید تیم مالی فعال می‌شه.' },
      'پلن‌های بلندمدت قیمت هر ماهشون پایین‌تره.',
    ],
    sub: 'آپلود رسید جعلی یا نامعتبر تخلفه و می‌تونه به لغو سفارش و مسدود شدن حساب منجر بشه.',
    nav: { label: 'صفحه‌ی پلن‌ها', path: '/plans' },
  },
  about: {
    text: 'سکویا فقط یه اپ تمرین نیست؛ پلتفرمیه که مربی واقعی و ابزارهای هوشمند رو کنار هم گذاشته.',
    bullets: [
      'برنامه‌ت رو یه مربی سکویا خودش برات می‌نویسه — نه یه قالب آماده.',
      'اجرای برنامه، ویدیوی هر تمرین، ثبت ست‌ها، تغذیه، پیگیری پیشرفت و گفتگو با مربی، همه توی یک اپ.',
    ],
    options: [
      { label: 'بگو دقیقاً چطور کار می‌کنه', to: 'about_how' },
      { label: 'بگو چه فرقی با بقیه داره', to: 'about_diff' },
      { label: 'نماد اعتماد سکویا رو نشونم بده', to: 'about_trust' },
      { label: 'قوانین و حریم خصوصی رو توضیح بده', to: 'rules' },
      { label: 'راه‌های ارتباط با سکویا رو بگو', to: 'links' },
    ],
  },
  about_how: {
    text: 'شش قدم، از ثبت‌نام تا نتیجه:',
    bullets: [
      { b: '۱ —', t: 'پلن رو انتخاب می‌کنی و مربیت رو از بین مربی‌های همون پلن برمی‌داری.' },
      { b: '۲ —', t: 'فرم سنجش رو پر می‌کنی: سابقه، هدف، محدودیت‌ها، اندازه‌ها و عکس‌ها.' },
      { b: '۳ —', t: 'مربی بررسی می‌کنه و برنامه‌ت رو اختصاصی می‌نویسه.' },
      { b: '۴ —', t: 'برنامه توی اپ تحویل داده می‌شه، با ویدیوی هر تمرین و جلسه‌های تقویم‌شده.' },
      { b: '۵ —', t: 'تمرین می‌کنی و ثبت می‌کنی: پلیر تمرین، تایمر استراحت، وزنه و تکرار هر ست.' },
      { b: '۶ —', t: 'هر ۲۱ روز پیگیری: وزن، اندازه‌ها و عکس‌ها ثبت می‌شه، مربی بازخورد می‌ده و برنامه به‌روز می‌شه.' },
    ],
    nav: { label: 'صفحه‌ی پلن‌ها', path: '/plans' },
  },
  about_trust: {
    text: 'نماد اعتماد به ما',
    enamad: true,
    options: [{ label: 'قوانین و حریم خصوصی رو توضیح بده', to: 'rules' }],
  },
  about_diff: {
    text: 'چیزی که سکویا رو جدا می‌کنه، یکجا بودن همه‌چیزه:',
    bullets: [
      { b: 'برنامه‌ی واقعاً اختصاصی —', t: 'نوشته‌ی مربی برای بدن و شرایط خودت.' },
      { b: 'اجرای برنامه داخل اپ —', t: 'پلیر تمرین با ویدیوی هر تمرین، تایمر استراحت و ثبت هر ست.' },
      { b: 'سنجش، نه حدس —', t: 'آنالیز ترکیب بدنی، ارزیابی پوسچر، تست حرکتی و نمودار وزن و BMI.' },
      { b: 'ابزارهای تخصصی —', t: 'RPE و 1RM، BMI و کالری، تایمر تاباتا و EMOM، برنامه‌ساز، آب بنوش! و پریود.' },
      { b: 'ارتباط مستقیم با مربی —', t: 'سکویا چت، بدون واسطه و بدون شماره‌ی شخصی.' },
    ],
    nav: { label: 'جعبه‌ابزار سکویا', path: '/sequoia-tools' },
  },
  tools: {
    text: 'بگو دنبال چی هستی تا مستقیم برم سراغش:',
    options: [
      { label: 'برای اندازه‌گیری و ارزیابی بدنم', to: 'tool_assess' },
      { label: 'برای زمان‌بندی تمرین و استراحت', to: 'tool_timer' },
      { label: 'می‌خوام خودم برنامه بسازم', to: 'tool_maker' },
      { label: 'برای یادآور و عادت روزانه', to: 'tool_habit' },
    ],
  },
  tool_assess: {
    text: 'دو ابزار داری:',
    bullets: [
      { b: 'محاسبه‌گر BMI —', t: 'شاخص توده بدنی، محدوده‌ی وزن هدف، BMR و کالری روزانه.' },
      { b: 'خودارزیابی حرکتی-اصلاحی —', t: 'تست‌های اسکوات، مچ، لگن و شانه با تمرین اصلاحی پیشنهادی.' },
    ],
    nav: { label: 'محاسبه‌گر BMI', path: '/sequoia-tools/bmi-calculator' },
  },
  tool_timer: {
    text: 'کرونومتر و تایمر تمرین: استراحت بین ست، اینتروال، تاباتا، EMOM و AMRAP، با ثبت دور و هشدار صوتی.',
    nav: { label: 'کرونومتر و تایمر', path: '/sequoia-tools/stopwatch' },
  },
  tool_maker: {
    text: 'با برنامه‌ساز می‌تونی برای خودت برنامه بچینی: انتخاب سطح، هدف و تجهیزات در دسترس، بعد اجرا با پلیر تمرین.',
    nav: { label: 'برنامه‌ساز', path: '/sequoia-tools/program-maker' },
  },
  tool_habit: {
    text: 'دو یادآور داری:',
    bullets: [
      { b: 'آب بنوش! —', t: 'هدف روزانه بر اساس وزن بدن، ثبت سریع و اعلان یادآوری.' },
      { b: 'یادآور دوره‌ی قاعدگی —', t: 'پیش‌بینی چرخه و نمایش فاز فعلی روی تقویم.' },
    ],
    nav: { label: 'آب بنوش!', path: '/sequoia-tools/water-reminder' },
  },
  rules: {
    text: 'کدومش رو می‌خوای؟',
    options: [
      { label: 'بگو عکس‌ها و اطلاعات سلامتی‌م کجا می‌ره', to: 'rules_photos' },
      { label: 'شرایط سنی و سلامتی رو بگو', to: 'rules_health' },
      { label: 'از کوکی‌ها و سرویس‌های ثالث بگو', to: 'rules_cookies' },
      { label: 'از پیامک، ایمیل و تلگرام بگو', to: 'rules_messaging' },
      { label: 'از اشتراک‌گذاری برنامه و تعلیق حساب بگو', to: 'rules_content' },
    ],
  },
  rules_photos: {
    text: 'موقع ثبت‌نام و فرم سنجش، نام، سن، وضعیت جسمانی، هدف ورزشی و تصاویر ازت گرفته می‌شه.',
    bullets: [
      'این‌ها فقط برای طراحی برنامه‌ی اختصاصی و بهبود کیفیت خدمات استفاده می‌شن.',
      'تصاویر فقط برای پیگیری روند پیشرفت و طراحی برنامه‌ست و بدون اجازه‌ی مستقیم خودت منتشر نمی‌شه.',
      'بهتره عکس‌ها رو بدون نمایش صورت بفرستی؛ چیزی که مربی برای ارزیابی لازم داره زاویه و حالت بدنه، نه چهره.',
    ],
    sub: 'داده‌هات روی سرور سکویا نگهداری می‌شه و دسترسی بهش محدود به مربی خودت و تیم پشتیبانیه.',
  },
  rules_health: {
    text: 'سه چیز که قبل از شروع باید بدونی:',
    bullets: [
      'استفاده از خدمات حداقل ۱۸ سال سن یا تأیید سرپرست قانونی لازم داره.',
      'اگه بیماری زمینه‌ای، مصدومیت یا شرایط خاص جسمانی داری، مشورت با پزشک قبل از شروع الزامیه.',
      'برنامه‌ها برای بهبود سبک زندگی و سلامت عمومی‌ان و جایگزین تشخیص یا درمان پزشکی نیستن.',
    ],
    sub: 'توی فرم سنجش اطلاعات سلامتی‌ت رو کامل و درست بنویس؛ اطلاعات ناقص یا نادرست مسئولیت عارضه‌ی احتمالی رو به عهده‌ی خودت می‌ذاره.',
  },
  rules_cookies: {
    text: 'سکویا از سرویس‌های شخص ثالث استفاده می‌کنه — درگاه پرداخت و ابزارهای تحلیل ترافیک و بهبود عملکرد — که کوکی یا فناوری مشابه به‌کار می‌برن.',
    bullets: [
      'این کوکی‌ها فقط برای بهبود تجربه‌ی کاربری و کیفیت خدماتن.',
      'هرکدوم تحت سیاست حریم خصوصی خودشون هم هستن.',
    ],
    nav: { label: 'متن کامل قوانین', path: '/privacy-policy' },
  },
  rules_messaging: {
    text: 'سکویا ممکنه از این کانال‌ها باهات در ارتباط باشه: پیامک، ایمیل، ربات تلگرام و اعلان داخل پنل.',
    bullets: [
      'موضوعش مشخصه: وضعیت سفارش، پیام مربی و پشتیبانی، و یادآوری‌های برنامه.',
      'این اطلاعات فقط برای ارائه‌ی خدمات استفاده می‌شه و در اختیار اشخاص ثالث غیرمرتبط قرار نمی‌گیره.',
    ],
    options: [{ label: 'قوانین دیگه رو هم بگو', to: 'rules' }],
  },
  rules_content: {
    text: 'دو قاعده که خوبه بدونی:',
    bullets: [
      { b: 'محتوا:', t: 'استفاده از برنامه‌ها، محتوای آموزشی و تصاویر سکویا بدون اجازه‌ی کتبی ممنوعه.' },
      { b: 'رفتار:', t: 'الفاظ توهین‌آمیز، محتوای نامرتبط یا مزاحمت برای مربی و پشتیبانی می‌تونه دسترسی‌ت رو محدود کنه.' },
      'در صورت نقض قوانین، سکویا می‌تونه دسترسی رو موقت یا دائم و بدون بازگشت وجه محدود کنه.',
    ],
    sub: 'این شرایط ممکنه هر زمان به‌روزرسانی بشه و نسخه‌ی جدید از لحظه‌ی انتشار معتبره.',
    nav: { label: 'متن کامل قوانین', path: '/privacy-policy' },
  },
  links: {
    text: 'از هر کدوم از این راه‌ها می‌تونی سکویا رو دنبال کنی یا باهامون در تماس باشی:',
    links: [
      { label: 'سکویا چت', handle: 'app.sequoia.fitness/support', url: APP_URL + '/support', action: 'شروع کن', icon: '/a/ico-chat-ico-860b555f.webp' },
      { label: 'اینستاگرام', handle: '@app_sequoia', url: 'https://instagram.com/app_sequoia', action: 'دنبال کن', icon: '/p/instagram-icon.webp' },
      { label: 'کانال تلگرام', handle: '@sequoiafitness_channel', url: 'https://t.me/sequoiafitness_channel', action: 'عضو شو', icon: '/p/tlgrm-icon.webp' },
      { label: 'یوتیوب', handle: '@Sequoia.fitness', url: 'https://www.youtube.com/@Sequoia.fitness', action: 'ببین', icon: '/p/ytube-icon.webp' },
      { label: 'وب‌سایت سکویا', handle: 'sequoia.fitness', url: 'https://sequoia.fitness', action: 'باز کن', icon: '/p/website-icon.webp' },
      { label: 'تماس با پشتیبانی', handle: '۰۲۱-۲۶۲۵۴۱۴۶', url: 'tel:+982126254146', action: 'تماس بگیر', officeHours: true, icon: '/p/phone.webp' },
      { label: 'ذخیره‌ی سکویا در مخاطبین', handle: 'شماره و همه‌ی لینک‌ها', url: '/sequoia.vcf', action: 'ذخیره کن', vcard: true },
    ],
  },
  support: {
    text: 'ارتباط با مربی، تیم مالی و پشتیبانی فقط از طریق همین سامانه‌ی گفتگوی داخل پنل انجام می‌شه و هر بخش ساعت کاری خودش رو داره.',
    nav: { label: 'مشاوره رایگان', path: '/support' },
  },
}
